const Builder = require('../BuilderBase');
const ThumbnailColumn = require('../listColumns/ThumbnailColumn');

module.exports = class CardList extends Builder {
    constructor(title, properties) {
        super('list_CardList', title, properties);
    }

    thumbnail(title, properties) {
        let image = new ThumbnailColumn(title, properties);
        this.addChildBlock(image, 'columns');
        return this;
    }
};
